import React, { useState } from "react";
import { DeleteCountriesPermission } from "../../constants/permissions";
import { usePermission } from "../../hooks/usePermission";
import CountriesTable from "../../Components/Countries/CountriesTable";
import CountryForm from "../../Components/Countries/CountryForm";
import { Box, Container, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function Countries() {
  const { data: canCreateCountry } = usePermission({
    permissionName: DeleteCountriesPermission,
  });

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="h4" component="h1">
            Countries
          </Typography>
          {canCreateCountry && (
            <button
              className="bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2"
              onClick={handleClickOpen}
            >
              <AddIcon />
              Add New Country
            </button>
          )}
        </Box>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <CountriesTable />
        </Paper>

        <CountryForm
          open={open}
          onClose={handleClose}
          formData={formData}
          onInputChange={handleInputChange}
        />
      </Box>
    </Container>
  );
}

export default Countries;
